
export const IS_AUTHENTICATED = "IS_AUTHENTICATED"
export const IS_AUTHENTICATED_SUCCESS = "IS_AUTHENTICATED_SUCCESS"


export const LOGOUT = "LOGOUT"

export const USER_INFO = "USER_INFO"
export const USER_INFO_SUCCESS = "USER_INFO_SUCCESS"

export const RESET_AUTH_STATE = "RESET_AUTH_STATE"

export const SPID = "SPID"
export const CFTNS = "CFTNS"

